export const CHAT_MESSAGES_REPOLL_INTERVAL = 60000
